import { DoCloudGameStopHS, DWCloudGameShouldFeedBack } from 'src/commons/store/CloudGameStore'
import { AppStore, GameLibraryStore } from 'src/pc/store/AppStore'
import { stringify } from 'querystring'
import { getPhpToken } from 'src/pc/utils/auth'
import { getUserInfo } from 'src/pc/store/UserStore'
import { generatorUUID } from 'src/pc/store/cloudGame/utils'
import { CLOUD_GAME_EXIT_TYPE, CLOUD_GAME_PROGRESS_STATUS } from 'src/pc/store/cloudGame/cloudGameHelper'
import clientPostMessage, { FrameOrigins } from 'src/pc/store/cloudGame/clientPostMessage'
import CloudGameClientStore from 'src/pc/store/cloudGame/cloudGameClientStore'
import SocketStore from 'src/pc/store/cloudGame/socket'
let timer: number | null = null
// 游戏运行心跳
export const gameIsRunningCheck = (gameCloudOrderNo: string, option?: { clearOnly: boolean }) => {
  timer && clearInterval(timer)
  timer = null
  if (!option?.clearOnly) {
    timer = window.setInterval(() => {
      SocketStore.send({
        packetNo: generatorUUID().replace(/-/g, 'x'),
        messageGroup: 'GAME_CLOUD',
        systemId: '99box',
        messageCode: 'cloud_game_running',
        data: { gameCloudOrderNo },
      })
    }, 1000 * 55)
  }
}

const useCloudGameStart = () => {
  /**
   * 启动云游戏
   * @param gameCloudOrderNo 云游戏启动单号
   * @param url 云游戏窗口url
   */
  const runCloudGame = async (gameCloudOrderNo: string, url: string) => {
    /** 清除之前的上号timeout计时器 */
    clearTimeOutCheck()
    console.debug(
      '云游戏启动进度-开始启动(参数拼接完成转为挂盘中状态)',
      CLOUD_GAME_PROGRESS_STATUS.GAME_INSTALLING,
      new Date().toLocaleString(),
    )
    CloudGameStartProgress.setStep(CLOUD_GAME_PROGRESS_STATUS.GAME_INSTALLING)
    CloudGameClientStore.cloudGameIframe.iframeSrc = url
    CloudGameClientStore.gameCloudNo = gameCloudOrderNo
    /** 启动超时的定时器 */
    checkCloudTimer = window.setTimeout(() => {
      stopCloudGame({
        needRequest: true,
        reason: CLOUD_GAME_EXIT_TYPE.CLIENT_START_TIME_OUT.reason,
        needArchive: false,
      })
      CloudGameClientStore.cloudGameStartCrash = CLOUD_GAME_EXIT_TYPE.CLIENT_START_TIME_OUT
      checkCloudTimer = null
    }, 60 * 1000 * 5)
  }

  const startCloudGame = async ({
    gameCloudOrderNo,
    gameJson,
    cloudArchive,
    isHang,
  }: {
    gameCloudOrderNo: string
    startGameNo?: string
    gameId?: number
    gameJson: string
    queue?: boolean
    cloudArchive?: TFinalArchive
    isHang: boolean
  }) => {
    const Authorization = getPhpToken()
    if (!Authorization) {
      return
    }
    CloudGameStartProgress.reset()
    CloudGameClientStore.cloudPageStatus = false
    console.debug(`当前游戏启动 ${!isHang ? '不' : ''} 需要挂盘`)
    console.debug(
      '云游戏启动进度-开始启动(拼接启动参数)',
      CLOUD_GAME_PROGRESS_STATUS.LOCK_DEVICE,
      new Date().toLocaleString(),
    )
    CloudGameStartProgress.setStep(CLOUD_GAME_PROGRESS_STATUS.LOCK_DEVICE)
    const json = gameJson ? JSON.parse(gameJson) : {}
    const userId = localStorage.getItem('user_id') || ''
    if (cloudArchive) {
      json.cloudArchiveOrder = cloudArchive.orderNo
      json.cloudOssPath = cloudArchive.key.split('#')[0]
    }
    json.disableWs = true
    json.prod_type = 'box'
    json.userId = userId
    json.parent = encodeURIComponent(window.origin)
    json.isHang = +isHang
    /** 缓存appId, 邀请玩家时需要使用 */
    if (json.appId) {
      localStorage.setItem('t_cloud_sdk_app_id', json.appId)
    }
    try {
      const userInfo = await getUserInfo(Authorization)
      if (userInfo.hasInvitationRight) {
        json.userType = 'host'
      }
      const url = `${FrameOrigins[process.env.BUILD_TYPE]}?Authorization=${Authorization}&${stringify(json)}`
      await runCloudGame(gameCloudOrderNo, url)
    } catch (error) {
      console.error(error)
    }
  }

  /**
   * 云游戏停止 通知客户端和服务端 并修改前端状态
   * @param needRequest 是否需要通知服务端停止计费
   */
  const stopCloudGame = async ({
    needRequest = true,
    reason = '',
    needArchive = true,
    needFeedBack,
  }: {
    needRequest: boolean
    reason: string
    needArchive?: boolean
    needFeedBack?: boolean
  }) => {
    if (!['starting', 'running'].includes(GameLibraryStore.gameRunStatus)) {
      return
    }
    CloudGameStartProgress.reset()
    const GameCloudNo = CloudGameClientStore.gameCloudNo
    const isSupportArchive = !!GameLibraryStore.currentTheRunningGameInfo?.isSupportArchive
    if (!needArchive) {
      CloudGameClientStore.gameCloudNo = ''
    }
    gameIsRunningCheck('', { clearOnly: true })
    clearTimeOutCheck()
    if (needRequest && GameCloudNo) {
      CloudGameClientStore.cloudGameIframe.iframeSrc = 'about:blank'
      console.log('调用停止计费接口')
      DoCloudGameStopHS.Execute({ gameCloudOrderNo: GameCloudNo, reason })
    }
    if (needFeedBack) {
      DWCloudGameShouldFeedBack.Execute().then(should => {
        if (!should) {
          return
        }
        if (isSupportArchive) {
          setTimeout(() => {
            AppStore.cloudGameFeedBackVisible = true
          }, 2000)
        } else {
          AppStore.cloudGameFeedBackVisible = true
        }
      })
    }
    if (GameCloudNo) {
      GameLibraryStore.gameRunStatus = 'waitClose'
      await awaitCloudSourceFreed()
    }
    GameLibraryStore.gameRunStatus = 'stop'
  }

  return {
    startCloudGame,
    stopCloudGame,
  }
}

export default useCloudGameStart

/** 等待释放云游戏资源 */
const awaitCloudSourceFreed: (timeout?: number) => Promise<{ state: 'done' | 'timeout' }> = (timeout = 15000) => {
  return new Promise(resolve => {
    setTimeout(() => {
      resolve({ state: 'timeout' })
    }, timeout)
  })
}

interface ProgressOption {
  interval?: number
  onchange: (step: number) => void
}

const loop = () => {}

export class CLOUD_GAME_PROGRESS {
  state: 'on' | 'off' | 'done' = 'off'
  timer: number | null = null
  interval: number = 1000
  targetStep: number = 0
  step: number = 0
  onchange: (step: number) => void = loop
  constructor({ interval = 1000, onchange = loop }: ProgressOption) {
    this.interval = interval
    this.onchange = onchange
  }
  setStep(n: number) {
    if (this.state === 'done') {
      return
    }
    if (n > this.targetStep) {
      this.targetStep = n
      if (this.state === 'off') {
        this.updateProgress()
      }
    }
  }
  updateProgress() {
    this.state = 'on'
    if (this.step >= this.targetStep) {
      this.state = 'off'
      return
    }
    this.timer = window.setTimeout(() => {
      this.step++
      this.onchange(this.step)
      this.updateProgress()
    }, this.interval)
  }
  finish() {
    this.state = 'done'
  }
  reset() {
    if (this.timer) {
      clearTimeout(this.timer)
      this.timer = null
    }
    this.step = 0
    this.targetStep = 0
    this.onchange(this.step)
  }
}

export const CloudGameStartProgress = new CLOUD_GAME_PROGRESS({
  onchange(step) {
    CloudGameClientStore.cloudGameStartProcess = step
    clientPostMessage.post({
      code: 'start-progress',
      process: {
        step,
        stepText: CLOUD_GAME_PROGRESS_TEXT[step],
      },
    })
  },
})

export enum CLOUD_GAME_PROGRESS_TEXT {
  '链接云服务器中' = 1,
  '云端游戏安装中' = 2,
  '链接云电脑服务' = 3,
  '启动游戏客户端' = 4,
  '启动成功' = 5,
}

let checkCloudTimer: number | null = null

export const clearTimeOutCheck = () => {
  if (checkCloudTimer) {
    window.clearTimeout(checkCloudTimer)
    checkCloudTimer = null
  }
}
